var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XTable',_vm._g(_vm._b({ref:"table",attrs:{"dataApi":_vm.dataApi,"columns":_vm.columns,"paging":false,"params":{id: _vm.workOrderId || _vm.getWorkOrderId}}},'XTable',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }